<template>
  <Tippy
    ref="popover"
    :arrow="true"
    trigger="click"
    interactive
    theme="light"
    placement="bottom"
  >
    <template #trigger>
      <div class="sort-option-selected">
        <div
          class="font-weight-bold text-secondary"
          style="font-size: 10px; min-width: 180px"
        >
          {{ $t('billingPlan.select.enabled') }}
        </div>
        <div
          style="font-size: 14px"
        >
          {{ selectedText }}
        </div>
      </div>
    </template>

    <div style="min-width: 180px">
      <div
        v-for="(k, i) in options"
        :key="k.key"
        class="sort-option text-left"
        :class="{ first: i === 0, active: selected === k.key }"
        @click="select(k.key)"
      >
        {{ k.text }}
      </div>
    </div>
  </Tippy>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    selected: String,
  },
  computed: {
    ...mapGetters(['payee']),
    selectedText() {
      return this.options.find((x) => x.key === this.selected)?.text;
    },
    options() {
      return [
        {
          key: 'all',
          text: this.$t('billingPlan.select.all'),
        },
        {
          key: 'enabled',
          text: this.$t('billingPlan.select.enabled'),
        },
        {
          key: 'disabled',
          text: this.$t('billingPlan.select.disabled'),
        },
      ];
    },
  },
  methods: {
    select(key) {
      this.$emit('update:selected', key);
      this.$refs.popover.tippy().hide();
    },
  },
};
</script>

<style lang="scss" scoped>
 @import './payers/style.scss';
</style>
